import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

/**
 * Force mobile/sheet-fullscreen behaviour when:
 *  – viewport width < MOBILE_BREAKPOINT, OR
 *  – viewport is square or portrait (height >= width)
 */
export function useForceSheetMobile(): boolean {
  const [forceMobile, setForceMobile] = React.useState(() => {
    if (typeof window === "undefined") return false;
    return (
      window.innerWidth < MOBILE_BREAKPOINT ||
      window.innerHeight >= window.innerWidth
    );
  });

  React.useEffect(() => {
    const evaluate = () => {
      setForceMobile(
        window.innerWidth < MOBILE_BREAKPOINT ||
          window.innerHeight >= window.innerWidth
      );
    };
    window.addEventListener("resize", evaluate);
    return () => window.removeEventListener("resize", evaluate);
  }, []);

  return forceMobile;
}
